"use strict";
(function (Drupal, once) {
    Drupal.behaviors.checkActiveMenuItem = {
        attach: function (context) {
            once('checkActiveMenuItem', '.js-mobile-expanded-menu-top-items', context).forEach(function (element) {
                // Loop through every child element of the top level menu
                const is_active = element.querySelector('#is-active');
                // If js-mobile-expanded-menu-top-items contains a child element with the id is-active
                if (is_active) {
                    // Remove the hidden class from the element
                    element.classList.remove('hidden');
                }
            });
        },
    };
})(Drupal, once);
